import { css } from "@emotion/core";

export const loggedCss = css`
    display: flex;
    width: 100%;
    padding-bottom: 10px;
    border-bottom: 1px solid #666;
    margin-bottom: 20px;
    align-items: center;

    .lg-char {
        display: flex;
        width: 30px;
        height: 30px;
        background-color: #ffb1ba;
        border-radius: 50%;
        font-size: 1.71rem;
        font-weight: 600;
        color: #fff;
        text-transform: uppercase;
        align-items: center;
        justify-content: center;
    }

    .lg-name {
        white-space: nowrap;
        padding: 0 10px;
        color: #666660;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;
